<template>
  <div style="background: #f2f6fc">
    <div style="width: 100%; background: #fff; margin-bottom: 20px">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        active-text-color="#409eff"
        style="width: 1200px; margin: 0 auto"
        :router="true"
      >
        <el-menu-item index="/home">工作台</el-menu-item>

        <el-submenu index="1" v-if="user.roles.includes(1)">
          <template slot="title">系统中心</template>
          <el-menu-item index="/system/sysUser">用户管理</el-menu-item>
          <el-menu-item index="/system/sysDept">部门管理</el-menu-item>
          <el-menu-item index="/system/sysLog">日志中心</el-menu-item>
        </el-submenu>

        <el-submenu
          index="2"
          v-if="user.roles.includes(1) || user.roles.includes(10) || user.roles.includes(12)"
        >
          <template slot="title">数据中心</template>
          <el-menu-item v-if="user.roles.includes(1) || user.roles.includes(12)" index="/apply/allApply">所有申请</el-menu-item>
          <el-menu-item v-if="user.roles.includes(1) || user.roles.includes(12)" index="/system/dealt/all">所有待办</el-menu-item>
          <el-menu-item v-if="user.roles.includes(1) || user.roles.includes(10)" index="/system/export">导出管理</el-menu-item>
        </el-submenu>

        <el-submenu
          index="3"
          v-if="user.roles.includes(1) || user.roles.includes(2)"
        >
          <template slot="title">财务中心</template>
          <el-menu-item index="/apply/allReimburse">所有内审单</el-menu-item>
        </el-submenu>

        <el-submenu
          index="4"
          v-if="
            user.roles.includes(1) ||
            user.roles.includes(4) ||
            user.roles.includes(8) ||
            user.roles.includes(9) ||
            user.roles.includes(13)
          "
        >
          <template slot="title">项目中心</template>
          <el-menu-item v-if="user.roles.includes(1) || user.roles.includes(4) || user.roles.includes(8)" index="/system/project/all">项目管理</el-menu-item>
          <el-menu-item
            index="/system/contract/all"
            v-if="user.roles.includes(1) || user.roles.includes(4) || user.roles.includes(9)"
            >合同管理</el-menu-item>
          <el-menu-item index="/system/payment/all" v-if="user.roles.includes(1) || user.roles.includes(4)">付款管理</el-menu-item>
          <el-menu-item index="/system/pettyCash/all" v-if="user.roles.includes(1) || user.roles.includes(4)">备用金管理</el-menu-item>
          <el-menu-item index="/system/delivery/all" v-if="user.roles.includes(1) || user.roles.includes(8) ||  user.roles.includes(13)">项目交付管理</el-menu-item>
        </el-submenu>

        <el-submenu
          index="5"
          v-if="user.roles.includes(1) || user.roles.includes(7) || user.roles.includes(9)"
        >
          <template slot="title">实施中心</template>
          <el-menu-item index="/system/enforceFile">实施文件</el-menu-item>
        </el-submenu>

        <el-submenu
          index="6"
          v-if="user.roles.includes(1) || user.roles.includes(11)"
        >
          <template slot="title">考勤中心</template>
          <el-menu-item index="/out/all">所有外出</el-menu-item>
          <el-menu-item index="/leave/all">所有请假</el-menu-item>
        </el-submenu>

        <el-submenu
          index="7"
          v-if="user.roles.includes(1) || user.roles.includes(3)"
        >
          <template slot="title">配置中心</template>
          <el-menu-item index="/system/baseSet">系统配置</el-menu-item>
          <el-menu-item index="/flow/flow">申请流程配置</el-menu-item>
          <el-menu-item index="/flow/line">流程审核线配置</el-menu-item>
        </el-submenu>

        <el-menu-item index="/user/center">个人中心</el-menu-item>
        <div style="float: right">
          <el-button
            @click="$router.push('/sys/siteLetter')"
            icon="el-icon-message"
            circle
          ></el-button>
          <el-button
            @click="logout"
            type="text"
            style="height: 60px; margin-left: 20px"
            icon="el-icon-arrow-left"
            >退出登录</el-button
          >
        </div>
      </el-menu>
    </div>
    <div style="width: 100%">
      <router-view />
    </div>
    <div
      style="
        height: 70px;
        padding-top: 30px;
        text-align: center;
        color: #a8a8a8;
        font-size: 12px;
        width: 700px;
        margin: 0 auto;
      "
    >
      <div
        style="
          height: 16px;
          line-height: 16px;
          margin-bottom: 5px;
          text-align: center;
        "
      >
        YMWK-OA
      </div>
      <div
        style="
          height: 16px;
          line-height: 16px;
          margin-bottom: 5px;
          text-align: center;
        "
      >
        ICP备1364512493号
      </div>
      <div
        style="
          height: 16px;
          line-height: 16px;
          margin-bottom: 5px;
          text-align: center;
        "
      >
        Copyright © 2023-至今 湖南御码网控信息技术有限公司 All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { AesDecrypt } from "@/util";

export default {
  name: "Header",
  data() {
    return {
      activeIndex: "1",
      user: {},
    };
  },
  methods: {
    logout() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.localStorage.clear();
          this.$router.push("/login");
        })
        .catch(() => {
          this.activeIndex = 1;
        });
    },
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
  },
};
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.navigation {
  width: 100%;
  margin-top: 30px;
  text-align: right;
  margin-right: 20px;
  float: left;
  color: #909399;
  font-size: 14px;
}

.footA:hover {
  color: #c0c4cc;
  cursor: pointer;
}

.butDiv {
  width: 200px;
  height: 56px;
  margin: 0 7px 25px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  display: inline-block;
  justify-content: flex-start;
  position: relative;
}

.butDiv:hover {
  cursor: pointer;
  border-color: rgb(192, 196, 204);
}

.smallbutDiv {
  display: flex;
  border-radius: 8px;
  width: 100%;
  margin-top: 10px;
  padding-left: 20px;
}

.butImg {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 5px;
}

.butSpan {
  text-align: left;
  line-height: 35px;
}

.secondary {
  color: #909399;
}

.noticeDiv:hover {
  cursor: pointer;
}

.el-badge__content.is-fixed {
  right: 17px;
}
</style>
